
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`Ce vaccin d'abord appelé Gam-Covid-Vac a été développé par le Centre national
russe d’épidémiologie et de microbiologie Gamaleya. La Russie cherche à
multiplier les accords de production pour fournir l’étranger plutôt que
d’exporter. L'entreprise biopharmaceutique Adienne, basée à Lugano, prévoit par
exemple de produire des doses dans son usine au nord de l'Italie.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;